export default __webpack_public_path__ + "static/media/2.3ade2c0b.jpg";